define(["require", "exports", "./util"], function (require, exports, util_1) {
    "use strict";
    exports.__esModule = true;
    exports.isHttps = function () { return window.location.protocol === 'https:'; };
    exports.isLocalHost = function () { return window.location.hostname === 'localhost'; };
    exports.isFacebookInAppBrowser = function () { return navigator.userAgent.indexOf('FBAN') >= 0 || navigator.userAgent.indexOf('FBAV') >= 0; };
    exports.isAndroid = function () { return navigator.userAgent.indexOf('Android') >= 0; };
    var _checkCamera = null;
    var _window = window;
    var enumerateDevices = (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) ? navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices)
        : ((_window.MediaStreamTrack && _window.MediaStreamTrack.getSources) ? _window.MediaStreamTrack.getSources.bind(_window.MediaStreamTrack)
            : null);
    exports.checkCamera = function () {
        if (_checkCamera) {
            return _checkCamera;
        }
        var deferred = $.Deferred();
        if (exports.isLocalHost()) {
            deferred.resolve({ hasCamera: true });
        }
        else if (enumerateDevices) {
            enumerateDevices()
                .then(function (devices) {
                deferred.resolve({
                    hasCamera: devices && !!util_1.findFirst(devices, function (d) { return d.kind === 'videoinput' || d.kind === 'video'; })
                });
            })["catch"](function (error) {
                deferred.resolve({ hasCamera: false, error: error });
            });
        }
        else {
            deferred.resolve({ hasCamera: false, error: new Error('no enumerateDevices') });
        }
        _checkCamera = deferred.promise();
        return _checkCamera;
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/device.js
// module id = 89
// module chunks = 0